import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null as string | null,
    token: ''
  }),
  actions: {
    login(username: string, password: string) {
      // 模拟API调用
      this.user = username
      this.token = 'mock-token'
    },
    logout() {
      this.user = null
      this.token = ''
    }
  },
  getters: {
    isAuthenticated: (state) => !!state.user
  }
})
